var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.97 23.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 8.97,
    width: 22.97,
    height: 4.06,
    rx: 1.27,
    ry: 1.27,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.2,13.53H1.77c-.98,0-1.77-.8-1.77-1.77v-1.52c0-.98,.8-1.77,1.77-1.77H22.2c.98,0,1.77,.79,1.77,1.77v1.52c0,.98-.79,1.77-1.77,1.77ZM1.77,9.47c-.43,0-.77,.35-.77,.77v1.52c0,.43,.35,.77,.77,.77H22.2c.42,0,.77-.35,.77-.77v-1.52c0-.42-.35-.77-.77-.77H1.77Z",
    fill: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.23,13.7l1.59,8.4c.05,.27,.29,.47,.56,.47h13.17c.28,0,.51-.2,.56-.47l1.55-8.4c.07-.35-.21-.68-.56-.68H3.79c-.36,0-.63,.33-.56,.68Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.55,23.07H5.38c-.51,0-.96-.37-1.05-.87l-1.59-8.4c-.06-.32,.02-.64,.23-.88s.51-.39,.83-.39H20.11c.32,0,.62,.14,.82,.39s.29,.57,.23,.88l-1.55,8.4c-.09,.51-.54,.88-1.06,.88ZM3.79,13.53l-.07,.09,1.59,8.4,13.25,.06,1.63-8.46-16.39-.09Z",
    fill: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 7.91,
    y: 15.12,
    width: 0.79,
    height: 4.97,
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15.36,
    y: 15.12,
    width: 0.68,
    height: 4.97,
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 11.52,
    y: 15.12,
    width: 1.04,
    height: 4.97,
    fill: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.2,
    y: 1.58,
    width: 14.73,
    height: 10.19,
    rx: 0.99,
    ry: 0.99,
    transform: "translate(-1.11 2.76) rotate(-11.99)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.52,13.35c-.85,0-1.62-.6-1.81-1.47l-1.53-7.18c-.21-1,.43-1.98,1.43-2.19L17.23,.04c.48-.1,.98-.01,1.39,.26,.41,.27,.7,.68,.8,1.17l1.53,7.18c.1,.48,.01,.98-.26,1.39s-.68,.7-1.17,.8l-11.62,2.47c-.13,.03-.26,.04-.39,.04ZM17.61,.86c-.07,0-.14,0-.21,.02L5.78,3.35c-.54,.11-.88,.64-.77,1.18l1.53,7.18c.11,.54,.64,.88,1.18,.76l11.62-2.47c.26-.06,.48-.21,.63-.43,.15-.22,.19-.49,.14-.75l-1.53-7.18c-.06-.26-.21-.48-.43-.63-.16-.11-.35-.16-.54-.16Z",
    fill: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 8.17,
    cy: 10.93,
    r: 0.5,
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 9.62,
    cy: 10.62,
    r: 0.5,
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.13,
    cy: 10.3,
    r: 0.5,
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 12.57,
    cy: 9.99,
    r: 0.5,
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 15.86,
    cy: 8.7,
    r: 0.96,
    fill: "#e2eaf0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 18.28,
    cy: 8.31,
    r: 1.01,
    fill: "#c6d6e0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 5.25,
    y: 3.92,
    width: 13.9,
    height: 2.24,
    transform: "translate(-.78 2.64) rotate(-11.99)",
    fill: "#cccccc"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentInactive);
export default __webpack_public_path__ + "static/media/paymentInactive.062878d4ddaaf4e4a090dcbdcb471649.svg";
export { ForwardRef as ReactComponent };